var objectMapper = require('object-mapper');

export const postOfficeAddressMapper = (data: any) => objectMapper(data, map);

const map = {
    "city": "city",
    "country": "country",
    "countryCode": "countryCode",
    "postalCode": "postalCode"
}